import { Link, useNavigate } from 'react-router-dom'
import { withCountRu } from '@dorixona/utils'
import { Icon } from '../../ui/Icon'
import { Failed } from '../../ui/Load'
import { TableSkeleton } from '../../ui/Skeleton'
import { PageActions } from '../../app/PageHeader'
import { useRoles } from './api'
import { moduleName, openModules, rolePermission } from './model'

/** Сколько разделов видно меткой; остальные — «+N»: строка не переносится. */
const SHOWN_MODULES = 5

/** Роли и то, что они открывают. Настраивается внутри роли. */
export function RolesScreen() {
  const navigate = useNavigate()
  const roles = useRoles()

  return (
    <>
      <PageActions>
        {roles.data ? (
          <span
            className="ui-count adm-count"
            aria-label={withCountRu(roles.data.items.length, ['роль', 'роли', 'ролей'])}
          >
            {roles.data.items.length}
          </span>
        ) : null}
        <span className="spacer" />
      </PageActions>

      <section className="ui-table-card" aria-label="Роли доступа">
        {roles.isPending ? <TableSkeleton what="роли" /> : null}
        {roles.isError ? (
          <Failed
            what="роли"
            error={roles.error}
            onRetry={() => {
              void roles.refetch()
            }}
          />
        ) : null}

        {roles.data ? (
          <div className="ui-table-wrap">
            <table className="ui-table ui-roles">
              <colgroup>
                <col className="w-role" />
                <col className="w-staff" />
                <col className="w-open" />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">Роль</th>
                  <th scope="col" data-align="end">
                    Сотрудников
                  </th>
                  <th scope="col" data-align="end">
                    Разделов открыто
                  </th>
                  <th scope="col">Что может делать</th>
                </tr>
              </thead>
              <tbody>
                {roles.data.items.length === 0 ? (
                  <tr>
                    <td colSpan={4}>
                      <div className="ui-empty">
                        <Icon name="i-key" />
                        <b>Ролей пока нет</b>
                      </div>
                    </td>
                  </tr>
                ) : null}
                {roles.data.items.map((role) => {
                  const href = `/roles/${role.id}`
                  const open = openModules(role, roles.data.modules)
                  const full = roles.data.modules.filter(
                    (module) => rolePermission(role, module) === 'crud',
                  ).length
                  return (
                    <tr
                      key={role.id}
                      data-href={href}
                      onClick={() => {
                        void navigate(href)
                      }}
                    >
                      <td>
                        <span className="name">
                          <Link
                            to={href}
                            className="primary"
                            onClick={(event) => {
                              event.stopPropagation()
                            }}
                          >
                            {role.name}
                          </Link>
                          {/* Ключ вместо замка-эмодзи: системность читает подпись ниже,
                              значок только помогает найти такие роли глазом. */}
                          {role.system ? <Icon name="i-key" size={14} /> : null}
                        </span>
                        <span className="secondary">
                          {role.system
                            ? 'системная роль · права изменить нельзя'
                            : full
                              ? `${withCountRu(full, ['раздел', 'раздела', 'разделов'])} с полным доступом`
                              : 'ограниченный доступ'}
                        </span>
                      </td>
                      <td data-align="end">{role.staffCount}</td>
                      <td data-align="end">
                        {open.length} из {roles.data.modules.length}
                      </td>
                      <td>
                        {/* Метки в одну строку: в узкой колонке обрезаются сами
                            метки, а «+N» остаётся видно всегда. */}
                        <span className="perms">
                          <span className="list">
                            {open.length === 0 ? <span className="ui-tag">нет доступа</span> : null}
                            {open.slice(0, SHOWN_MODULES).map((module) => (
                              <span className="ui-tag" key={module}>
                                {moduleName(module).split(' ')[0]}{' '}
                                <b>{rolePermission(role, module).toUpperCase()}</b>
                              </span>
                            ))}
                          </span>
                          {open.length > SHOWN_MODULES ? (
                            <span className="ui-tag">+{open.length - SHOWN_MODULES}</span>
                          ) : null}
                        </span>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        ) : null}
      </section>
    </>
  )
}
